import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";
import RefundAnomalyScoreList from "../../interfaces/RefundAnomalyScoreList";

const REFUND_ANALYSIS_API_URL =
  process.env.REACT_APP_REFUND_ANALYSIS_API_BASE_URL;
const getAllAnomalyScores = (
  userEmail: String,
  startDate: String,
  endDate: String
): Promise<RefundAnomalyScoreList> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: REFUND_ANALYSIS_API_URL + "/refund-anomaly-scores/feedback",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { userEmail: userEmail, startDate: startDate, endDate: endDate },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not Retrieve Refund Analysis Information";
      throw error;
    });
};

const saveAllScoresInformation = (sherlockFeedback: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: REFUND_ANALYSIS_API_URL + "/refund-anomaly-scores/feedback",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: sherlockFeedback,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

export { getAllAnomalyScores, saveAllScoresInformation };
